module.exports = __webpack_public_path__ + "img/pathology-rotation.8aca45bb.png";